import { render, staticRenderFns } from "./AllSurveys.vue?vue&type=template&id=5a312e67"
import script from "./AllSurveys.vue?vue&type=script&lang=js"
export * from "./AllSurveys.vue?vue&type=script&lang=js"
import style0 from "./AllSurveys.vue?vue&type=style&index=0&id=5a312e67&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports